/** The device brands: registering a device and its page — English, the source of the other languages */
const devices = {
  "devices.registered": "Device registered",
  "devices.registrationFailed": "Registration failed",
  "devices.siteRegistered": "{name} registered",
  "devices.registerAnother": "Register another",
  "devices.openDevice": "Open device",
  "devices.viewAllSites": "View all sites",
  "devices.deviceAddress": "Device address *",
  "devices.username": "Username *",
  "devices.password": "Password *",
  "devices.siteName": "Site name",
  "devices.connectRegister": "Connect & register",
  "devices.directDevice": "Direct device",
  "devices.deviceUrl": "Device URL *",
  "devices.reachableVpn": "Must be reachable from this server — usually over the VPN tunnel.",
  "devices.storedEncrypted": "Stored encrypted.",
  "devices.imported": { one: "{count} device imported", other: "{count} devices imported" },
  "devices.mikrotik.transport.rest": "REST API (RouterOS 7)",
  "devices.mikrotik.transport.apiSsl": "API protocol over TLS",
  "devices.mikrotik.transport.api": "API protocol (unencrypted)",
  "devices.mikrotik.radios": { one: "{count} radio", other: "{count} radios" },
  "devices.mikrotik.connectedOver": "Connected over: {transport}",
  "devices.mikrotik.registerTitle": "Register MikroTik",
  "devices.mikrotik.registerSubtitle": "A router, access point or point-to-point / point-to-multipoint radio",
  "devices.mikrotik.addressHint": "Must be reachable from this server — usually its VPN address. The connection type is detected: REST on RouterOS 7, the API service (8729 or 8728) on RouterOS 6.43 and newer.",
  "devices.mikrotik.forceHint": "To force one, write",
  "devices.or": "or",
  "devices.mikrotik.accountHint": "Use an account with full rights if you want to configure the device from here; a read-only account is enough for monitoring. Stored encrypted.",
  "devices.mikrotik.siteNameHint": "(optional — defaults to the device identity)",
  "devices.mikrotik.siteNamePlaceholder": "e.g. Sector north",
  "devices.mikrotik.radioLinkTitle": "For a radio link",
  "devices.mikrotik.radioLinkText": ", register each end as its own site. The access point then shows every station with signal and rate; a station that is also registered here is recognised as a link even on a plain WiFi access point.",
  "devices.peplink.foundOrgs": { one: "Found {count} organisation", other: "Found {count} organisations" },
  "devices.peplink.discoveryFailed": "Discovery failed",
  "devices.peplink.telemetryNote": "SpeedFusion and WAN telemetry appear after the first sync.",
  "devices.peplink.registerTitle": "Register Peplink",
  "devices.peplink.registerSubtitle": "Connect via InControl2 or directly to a router",
  "devices.peplink.ic2Desc": "Imports every device in an org or group.",
  "devices.peplink.directDesc": "Polls one Balance/MAX router locally.",
  "devices.peplink.clientId": "Client ID *",
  "devices.peplink.clientSecret": "Client secret *",
  "devices.createUnder": "Create under",
  "devices.peplink.ic2Url": "IC2 API URL",
  "devices.peplink.discoverOrgs": "Discover organisations",
  "devices.peplink.organisation": "Organisation *",
  "devices.peplink.group": "Group",
  "devices.peplink.blankAllGroups": "(blank = all groups)",
  "devices.peplink.allGroups": "All groups",
  "devices.peplink.siteNamePlaceholder": "e.g. Boat 1 — MAX Transit",
  "devices.teltonika.importedFromRms": { one: "Imported {count} device from RMS", other: "Imported {count} devices from RMS" },
  "devices.teltonika.telemetryNote": "Cellular telemetry will start appearing after the first sync.",
  "devices.teltonika.registerTitle": "Register Teltonika",
  "devices.teltonika.registerSubtitle": "Connect via RMS cloud or directly to a router",
  "devices.teltonika.rmsCloud": "RMS cloud",
  "devices.teltonika.rmsDesc": "Imports every device in your RMS company. Best for fleets.",
  "devices.teltonika.directDesc": "Polls one RutOS router over its local API.",
  "devices.teltonika.pat": "Personal access token *",
  "devices.teltonika.createInRms": "Create in RMS under",
  "devices.teltonika.rmsUrl": "RMS API URL",
  "devices.teltonika.defaultRms": "Leave blank for the default public RMS.",
  "devices.teltonika.siteNamePlaceholder": "e.g. Van 3 — RUTX11",
  "devices.unifihost.consoles": { one: "{count} console", other: "{count} consoles" },
  "devices.unifihost.found": "Found {consoles} and {sites}",
  "devices.unifihost.verificationFailed": "Verification failed",
  "devices.unifihost.importedSites": { one: "{count} site imported", other: "{count} sites imported" },
  "devices.unifihost.importFailed": "Import failed",
  "devices.unifihost.doneNote": "Site Manager gives read-only fleet telemetry and ISP metrics. For configuration, also add the local controller as a UniFi site.",
  "devices.unifihost.importMore": "Import more",
  "devices.unifihost.title": "Connect UniFi Site Manager",
  "devices.unifihost.subtitle": "Fleet-wide monitoring across every UniFi console on your account",
  "devices.unifihost.apiKey": "API key *",
  "devices.unifihost.apiKeyPlaceholder": "UniFi Site Manager API key",
  "devices.unifihost.createAt": "Create at",
  "devices.unifihost.baseUrl": "API base URL",
  "devices.unifihost.verifyDiscover": "Verify & discover",
  "devices.unifihost.importAs": "Import as",
  "devices.unifihost.perSite": "One site per UniFi site",
  "devices.unifihost.recommended": "{sites} — recommended",
  "devices.unifihost.perConsole": "One site per console",
  "devices.unifihost.consolesToImport": "Consoles to import",
  "devices.unifihost.console": "console",
  "devices.unifihost.importConsoles": { one: "Import {count} console", other: "Import {count} consoles" },
  "devices.velanox.registeredFromEndpoint": { one: "Registered {count} box from endpoint", other: "Registered {count} boxes from endpoint" },
  "devices.velanox.standaloneRegistered": "Standalone box registered: {name}",
  "devices.velanox.boxesRegistered": { one: "{count} box registered", other: "{count} boxes registered" },
  "devices.velanox.boxRegistered": "Box registered",
  "devices.velanox.endpointNote": "Sites created for each box on the endpoint. They will sync automatically.",
  "devices.velanox.boxNote": "Standalone box has been added as a site.",
  "devices.velanox.registerTitle": "Register Velanox site",
  "devices.velanox.registerSubtitle": "Connect a Velanox One Speed endpoint or standalone box",
  "devices.velanox.endpoint": "Endpoint",
  "devices.velanox.endpointDesc": "Aggregates multiple boxes. Auto-creates one site per box.",
  "devices.velanox.standalone": "Standalone box",
  "devices.velanox.standaloneDesc": "A single box polled directly.",
  "devices.velanox.endpointName": "Endpoint name",
  "devices.velanox.endpointNamePlaceholder": "e.g. Amsterdam endpoint",
  "devices.velanox.endpointNameHint": "Used as a label — individual box names come from the API.",
  "devices.velanox.siteNamePlaceholder": "e.g. Starlinkhuren mobile unit",
  "devices.velanox.url": "Velanox URL *",
  "devices.velanox.baseUrlEndpoint": "Base URL of the endpoint Flask server.",
  "devices.velanox.baseUrlBox": "Base URL of the standalone box HTTP server.",
  "devices.velanox.token": "Integration token *",
  "devices.velanox.setVia": "Set via",
  "devices.velanox.onNode": "on the Velanox node.",
  "devices.velanox.descriptionPlaceholder": "Optional notes about this connection",
  "devices.actionFailed": "Action failed",
  "devices.actionSent": "\"{action}\" sent",
  "devices.action.reboot": "reboot",
  "devices.action.firmware_check": "firmware check",
  "devices.action.tunnel_reconnect": "tunnel reconnect",
  "devices.action.wan_enable": "WAN enable",
  "devices.action.wan_disable": "WAN disable",
  "devices.action.send_sms": "send SMS",
  "devices.action.restart_modem": "restart modem",
  "devices.action.switch_sim": "switch SIM",
  "devices.action.restart_network": "restart network",
  "devices.action.roll_key": "roll key",
  "devices.action.restart_service": "restart service",
  "devices.action.get_stats": "get stats",
  "devices.action.fetch_logs": "fetch logs",
  "devices.action.starlink_stow": "stow dish",
  "devices.action.starlink_unstow": "unstow dish",
  "devices.action.starlink_reboot": "reboot dish",
  "devices.upFor": "up {duration}",
  "devices.memory": "Memory",
  "devices.temperature": "Temperature",
  "devices.openMap": "Open map",
  "devices.controls": "Device controls",
  "devices.checkFirmware": "Check firmware",
  "devices.sendSms": "Send SMS",
  "devices.reboot": "Reboot",
  "devices.sms.recipient": "Recipient number",
  "devices.sms.message": "Message",
  "devices.sms.charges": "Sent from the router's SIM. Carrier charges apply.",
  "devices.signal.0": "No signal",
  "devices.signal.1": "Very poor",
  "devices.signal.2": "Poor",
  "devices.signal.3": "Fair",
  "devices.signal.4": "Good",
  "devices.signal.5": "Excellent",
  "devices.unknown": "unknown",
  "devices.unknownError": "Unknown error",
  "devices.up": "Up",
  "devices.connected": "Connected",
  "devices.loss": "{percent}% loss",
  "devices.interface": "Interface",
  "devices.ipAddress": "IP address",
  "devices.gateway": "Gateway",
  "devices.enable": "Enable",
  "devices.disable": "Disable",
  "devices.device": "Device",
  "devices.firmware": "Firmware",
  "devices.mikrotik.updateCheckDone": "Update check done",
  "devices.mikrotik.installedLatest": "Installed {installed}, latest {latest}",
  "devices.mikrotik.noNewer": "No newer version reported",
  "devices.mikrotik.backupSaved": "Backup saved",
  "devices.mikrotik.rebootSent": "Reboot sent",
  "devices.mikrotik.backInMinute": "The device is back in a minute or two.",
  "devices.mikrotik.renamePrompt": "Name for this link",
  "devices.mikrotik.renameFailed": "Rename failed",
  "devices.mikrotik.forgetConfirm": "Forget {name}? Use this for a station that was removed on purpose — it comes back by itself if it reconnects.",
  "devices.mikrotik.forgetFailed": "Could not remove the link",
  "devices.mikrotik.device": "MikroTik device",
  "devices.mikrotik.updateBadge": "update {version}",
  "devices.mikrotik.via": "via {transport}",
  "devices.mikrotik.configure": "Configure",
  "devices.mikrotik.checkUpdates": "Check updates",
  "devices.mikrotik.backup": "Backup",
  "devices.mikrotik.rebootConfirm": "Reboot this device? Links through it drop for a minute or two.",
  "devices.mikrotik.cannotReach": "Cannot reach the device{reason}. Links below are as last seen.",
  "devices.mikrotik.links": "Links",
  "devices.mikrotik.wifiClients": { one: "{count} WiFi client", other: "{count} WiFi clients" },
  "devices.mikrotik.radioLinks": "Radio links",
  "devices.mikrotik.noLinks": "No links seen yet. They appear after the first sync once a station is connected.",
  "devices.mikrotik.farEnd": "Far end",
  "devices.mikrotik.signal": "Signal",
  "devices.mikrotik.rate": "Rate ↑ / ↓",
  "devices.mikrotik.quality": "Quality",
  "devices.mikrotik.distance": "Distance",
  "devices.mikrotik.roleAp": "access point",
  "devices.mikrotik.roleStation": "station",
  "devices.mikrotik.onInterface": "on {interface}",
  "devices.mikrotik.linkDown": "link down",
  "devices.mikrotik.seen": "seen {when}",
  "devices.mikrotik.rename": "Rename",
  "devices.mikrotik.forget": "Forget this link",
  "devices.mikrotik.noWireless": "No wireless interfaces",
  "devices.mikrotik.mode": "Mode",
  "devices.mikrotik.channel": "Channel",
  "devices.mikrotik.state": "State",
  "devices.mikrotik.disabled": "disabled",
  "devices.mikrotik.running": "running",
  "devices.mikrotik.notConnected": "not connected",
  "devices.mikrotik.uplinks": "Uplinks",
  "devices.mikrotik.noUplink": "No uplink found. An interface counts as one when it is in the “WAN” interface list or carries the default route.",
  "devices.mikrotik.address": "Address",
  "devices.mikrotik.order": "Order",
  "devices.mikrotik.signalAria": "signal {percent} percent",
  "devices.peplink.cannotReach": "Cannot reach the Peplink device — check credentials",
  "devices.peplink.wansUp": "WANs up",
  "devices.peplink.tunnels": "SpeedFusion tunnels",
  "devices.storedLine": "Last read {when} — reading the router now…",
  "devices.storedLineNever": "Not read yet — reading the router now…",
  "devices.peplink.wanLinks": "WAN links",
  "devices.peplink.unknownCarrier": "Unknown carrier",
  "devices.peplink.rebootConfirm": "Reboot this Peplink device? All links drop for 1-2 minutes.",
  "devices.teltonika.cannotReach": "Cannot reach the Teltonika device — check credentials and connectivity",
  "devices.teltonika.modems": "Modems",
  "devices.teltonika.power.title": "Power",
  "devices.teltonika.power.noBattery": "No battery",
  "devices.teltonika.power.onMains": "On mains",
  "devices.teltonika.power.onBattery": "On backup power since {time} ({duration})",
  "devices.teltonika.power.notKnown": "Not known",
  "devices.teltonika.power.has": "Has backup power (UPS)",
  "devices.teltonika.power.notChanged": "The backup power setting was not changed",
  "devices.teltonika.noModems": "No cellular modems reported",
  "devices.teltonika.noOperator": "No operator",
  "devices.teltonika.band": "Band {band}",
  "devices.teltonika.dataUsage": "Data usage",
  "devices.teltonika.restartModem": "Restart modem",
  "devices.teltonika.switchSimConfirm": "Switch {modem} to the other SIM slot?",
  "devices.teltonika.switchSim": "Switch SIM",
  "devices.teltonika.wanInterfaces": "WAN interfaces",
  "devices.teltonika.noWans": "No WAN interfaces reported",
  "devices.teltonika.rebootConfirm": "Reboot this device? It will be offline for 1-2 minutes.",
  "devices.teltonika.vpnMode": "Programmed on the bench",
  "devices.teltonika.vpnModeDesc": "By its serial number, with its own VPN certificate",
  "devices.teltonika.serial": "Serial number",
  "devices.teltonika.serialHint": "As on its label; spaces do not matter. The same serial again refreshes this router and gives it a new certificate.",
  "devices.teltonika.model": "Model",
  "devices.teltonika.modelHint": "The model may stay empty: the router reports its own when it first connects.",
  "devices.teltonika.vpnLogin": "Velanox login on the router",
  "devices.teltonika.vpnLoginHint": "The user Velanox signs in with through the tunnel. The password is stored encrypted and never shown again.",
  "devices.teltonika.addRouter": "Add router",
  "devices.teltonika.routerAdded": "Router added",
  "devices.teltonika.routerAddedText": "Its VPN certificate is issued: load its .ovpn on the router from this page.",
  "devices.teltonika.addFailed": "The router was not added",
  "devices.teltonika.vpn.waiting": "Waiting for the router",
  "devices.teltonika.vpn.noAccount": "This router has no VPN certificate yet: add it again with the same serial number to issue one.",
  "devices.teltonika.vpn.newCertConfirm": "Issue a new VPN certificate for {name}? The current one stops working at once; the router stays off the VPN until it has the new file.",
  "devices.teltonika.vpn.newCertDoneText": "Download the new .ovpn and load it on the router.",
  "devices.teltonika.vpn.stepsTitle": "Load it on the router (RutOS WebUI)",
  "devices.teltonika.vpn.step1": "Services → VPN → OpenVPN: add a client instance named velanox.",
  "devices.teltonika.vpn.step2": "Turn it on, turn on “{option}” and choose {file}. Save.",
  "devices.teltonika.vpn.step3": "The router dials in; this card shows Connected within a few minutes.",
  "devices.unifihost.consoleName": "UniFi console",
  "devices.unifihost.readOnly": "Read-only cloud view. To change settings, register the local controller as a UniFi site.",
  "devices.unifihost.online": "online",
  "devices.unifihost.offline": "offline",
  "devices.unifihost.onConsole": "on this console",
  "devices.unifihost.connected": "connected",
  "devices.unifihost.updates": "Updates",
  "devices.unifihost.firmwareAvailable": "firmware available",
  "devices.unifihost.ispPerformance": "ISP performance",
  "devices.unifihost.last24h": "Last 24h",
  "devices.unifihost.last30d": "Last 30d",
  "devices.unifihost.noIsp": "No ISP metrics reported for this console",
  "devices.unifihost.updateBadge": "⬆ update",
  "devices.velanox.cannotReach": "Cannot reach Velanox box — check the integration token and URL",
  "devices.velanox.keyRollPending": "🔑 Key roll pending",
  "devices.velanox.wans": { one: "{count} WAN", other: "{count} WANs" },
  "devices.velanox.encrypted": "🔒 encrypted",
  "devices.velanox.na": "N/A",
  "devices.velanox.rttBonded": "RTT (bonded)",
  "devices.velanox.packetLoss": "Packet loss",
  "devices.velanox.wanPaths": "WAN paths",
  "devices.velanox.noWanPaths": "No WAN paths",
  "devices.velanox.jitter": "Jitter",
  "devices.velanox.loss": "Loss",
  "devices.velanox.weight": "Weight",
  "devices.velanox.anchor": "Anchor",
  "devices.velanox.alive": "Alive",
  "devices.velanox.roaming": "Roaming",
  "devices.velanox.boxControls": "Box controls",
  "devices.velanox.controlsNote": "Control actions are relayed to the box via the management channel. Reboot will cause a brief outage.",
  "devices.velanox.rollKey": "Roll key",
  "devices.velanox.restartService": "Restart service",
  "devices.velanox.getStats": "Get stats",
  "devices.velanox.fetchLogs": "Fetch logs",
  "devices.velanox.rebootBox": "Reboot box",
  "devices.velanox.rebootConfirm": "Reboot this Velanox box? This will cause a brief outage.",
  "devices.velanox.starlinkUnavailable": "Starlink status is not available{reason}.",
  "devices.velanox.loadingStarlink": "Loading Starlink status…",
  "devices.velanox.noDriver": "No Starlink driver connected to this box. The box reports driver: null.",
  "devices.velanox.capabilities": "Starlink capabilities",
  "devices.velanox.driver": "Driver: {driver}",
  "devices.velanox.reposition": "Reposition is never available on real Starlink hardware — dishes self-orient.",
  "devices.velanox.dishControls": "Dish controls",
  "devices.velanox.greyedNote": "Buttons are greyed out when the dish does not support that capability.",
  "devices.velanox.grpcNote": "Note: dish control via endpoint returns 501 (pending integration). Use standalone box mode for dish control.",
  "devices.velanox.stow": "Stow dish",
  "devices.velanox.unstow": "Unstow dish",
  "devices.velanox.rebootDish": "Reboot dish",
  "devices.velanox.rebootDishConfirm": "Reboot the Starlink dish?",
  "devices.velanox.dishStatus": "Dish status",
  "devices.velanox.notSupported": "{label} not supported by this box",
  "devices.velanox.preset.firmware": "Firmware status",
  "devices.velanox.preset.gateway": "Gateway status",
  "devices.velanox.preset.firewall": "Firewall rules",
  "devices.velanox.preset.dhcp": "DHCP leases",
  "devices.velanox.preset.interfaces": "Interfaces",
  "devices.velanox.preset.arp": "ARP table",
  "devices.velanox.invalidJson": "Body is not valid JSON",
  "devices.velanox.requestFailed": "Request failed",
  "devices.velanox.passThrough": "OPNsense pass-through. The box enforces its configured access level — denied calls return 403. Level 3 can reboot or reconfigure the firewall.",
  "devices.velanox.quickPresets": "Quick presets",
  "devices.velanox.httpMethod": "HTTP method",
  "devices.velanox.apiPath": "API path",
  "devices.velanox.requestBody": "Request body (JSON, optional)",
  "devices.velanox.response": "Response",
  "devices.unifihost.connectedSince": "Connected since",
  "devices.unifihost.managedBy": "Managed by",
  "devices.unifihost.mgmt.GATEWAY": "Gateway",
  "devices.unifihost.mgmt.SWITCH": "Switch",
  "devices.unifihost.mgmt.UNMANAGED": "Not managed",
  "devices.unifihost.defaultNetwork": "default",
  "devices.unifihost.security": "Security",
  "devices.unifihost.bands": "Bands",
  "devices.unifihost.network": "Network",
  "devices.unifihost.nativeNetwork": "Native network",
  "devices.unifihost.sec.OPEN": "Open",
  "devices.unifihost.sec.WPA2_PERSONAL": "WPA2-Personal",
  "devices.unifihost.sec.WPA3_PERSONAL": "WPA3-Personal",
  "devices.unifihost.sec.WPA2_WPA3_PERSONAL": "WPA2/WPA3-Personal",
  "devices.unifihost.sec.WPA2_ENTERPRISE": "WPA2-Enterprise",
  "devices.unifihost.sec.WPA3_ENTERPRISE": "WPA3-Enterprise",
  "devices.unifihost.sec.WPA2_WPA3_ENTERPRISE": "WPA2/WPA3-Enterprise",
  "devices.unifihost.why.rejected": "UniFi refused the API key for this console. The key must belong to the owner of the console.",
  "devices.unifihost.why.unsupported": "This console cannot give this list through the cloud. It needs UniFi OS 5.0.3 or later, and UniFi Network 10 or later for networks and WiFi.",
  "devices.unifihost.why.busy": "UniFi is limiting the requests to this console. Try again in a minute.",
  "devices.unifihost.why.unreachable": "The console did not answer through the cloud. Check that it is online.",
  "devices.unifihost.why.no_match": "This UniFi site is no longer on its console.",
  "devices.unifihost.why.failed": "UniFi did not provide this list.",
  "devices.unifilocal.open": "How to switch →",
  "devices.unifilocal.title": "Switch to the local controller",
  "devices.unifilocal.intro": "The console connects to the dashboard over a VPN tunnel of its own; the dashboard then reads and changes it through its own controller. The site keeps its name, alerts and subscriptions.",
  "devices.unifilocal.noPermission": "Switching needs the permissions to edit sites and to manage the VPN.",
  "devices.unifilocal.step.account": "Create the VPN account of this site",
  "devices.unifilocal.step.accountText": "The account gives the console its own certificate and a fixed address in the company's VPN network.",
  "devices.unifilocal.createAccount": "Create VPN account",
  "devices.unifilocal.creating": "Creating the account…",
  "devices.unifilocal.accountReady": "Ready: tunnel address {ip}",
  "devices.unifilocal.accountFailed": "The VPN account could not be created",
  "devices.unifilocal.step.download": "Download the VPN file",
  "devices.unifilocal.step.downloadText": "The .ovpn file holds this site's own certificate. Keep it private and use it only on this console.",
  "devices.unifilocal.download": "Download .ovpn",
  "devices.unifilocal.downloadFailed": "Download failed",
  "devices.unifilocal.step.client": "Add it to UniFi as a VPN client",
  "devices.unifilocal.client.1": "In UniFi Network, open Settings → VPN → VPN Client and choose Create New.",
  "devices.unifilocal.client.2": "VPN type: OpenVPN. Give it a name, for example Velanox.",
  "devices.unifilocal.client.3": "Upload the .ovpn file as the configuration file.",
  "devices.unifilocal.client.4": "Leave username and password empty: the file holds the certificate.",
  "devices.unifilocal.client.5": "Send no traffic through it: leave the routing wizards off and add no traffic route. Only the dashboard uses this tunnel.",
  "devices.unifilocal.client.6": "Choose Create. The connection comes up within a minute.",
  "devices.unifilocal.waiting": "Waiting for the tunnel to connect…",
  "devices.unifilocal.connected": "Tunnel connected",
  "devices.unifilocal.step.firewall": "Let the dashboard reach the console",
  "devices.unifilocal.firewall.why": "UniFi puts a VPN client connection in its External zone, which does not reach the console itself. Add a firewall policy that lets the dashboard in:",
  "devices.unifilocal.firewall.1": "UniFi Network 10: Settings → Policy Engine → Policy Table → Create New Policy. Older versions: Settings → Security → Firewall.",
  "devices.unifilocal.firewall.2": "Source: zone External, IP address {ip}.",
  "devices.unifilocal.firewall.3": "Destination: zone Gateway, port 443 (TCP).",
  "devices.unifilocal.firewall.4": "Action: Allow.",
  "devices.unifilocal.serverIpFallback": "the dashboard's tunnel address (the first address of the sites network)",
  "devices.unifilocal.step.key": "Create a local API key",
  "devices.unifilocal.key.1": "In UniFi Network: Settings → Control Plane → Integrations → Create API Key.",
  "devices.unifilocal.key.2": "Copy the key: UniFi shows it only once.",
  "devices.unifilocal.step.switch": "Switch the site to its local controller",
  "devices.unifilocal.apiKey": "Local API key",
  "devices.unifilocal.controllerUrl": "Controller address",
  "devices.unifilocal.controllerHint": "Filled in from the tunnel address. A self-hosted UniFi Network Server: https://<address>:8443",
  "devices.unifilocal.testSwitch": "Test and switch",
  "devices.unifilocal.testing": "Testing…",
  "devices.unifilocal.done": "The site now uses its local controller",
  "devices.unifilocal.why.rejected": "The console refused this API key. Create a new one under Control Plane → Integrations.",
  "devices.unifilocal.why.not_found": "The console answered, but not at this address. A self-hosted UniFi Network Server uses https://<address>:8443.",
  "devices.unifilocal.why.unreachable": "The console did not answer over the tunnel. Check that the VPN client is connected (step 3) and that the firewall policy lets the dashboard in (step 4).",
  "devices.unifilocal.why.no_vpn": "This site has no tunnel address yet (step 1).",
  "devices.unifilocal.why.failed": "The test did not succeed. Check the address and the API key.",
  "devices.unifilocal.manual.intro": "A UniFi OS console (Dream Machine, Cloud Gateway, Cloud Key) connects as an OpenVPN client with its site's .ovpn file, uploaded as it is.",
  "devices.unifilocal.manual.download": "Download the site's .ovpn file",
  "devices.unifilocal.manual.downloadText": "In the VPN accounts table above, on the site's row.",
  "devices.unifilocal.manual.add": "Add the site in the dashboard",
  "devices.unifilocal.manual.addText": "A site added through Site Manager: open it and choose the blue bar; it switches the site with you. A new site: add a UniFi site with the controller address https://<tunnel address>/proxy/network and the local API key.",
  "devices.mikrotik.vpnModeHint": "Velanox issues the unit its own VPN certificate. Load it on the unit; once the unit dials in, Velanox polls it through its tunnel. Nothing needs to be reachable now.",
  "devices.mikrotik.serial": "Serial number",
  "devices.mikrotik.serialHint": "As on its label; spaces and capitals do not matter. The same serial again refreshes this unit and gives it a new certificate.",
  "devices.mikrotik.unitRoleLabel": "Role",
  "devices.mikrotik.unitRoleNone": "None",
  "devices.mikrotik.unitRole.SENDER": "Sender",
  "devices.mikrotik.unitRole.RECEIVER": "Receiver",
  "devices.mikrotik.unitNameHint": "(optional — the serial number when empty)",
  "devices.mikrotik.vpnAccountHint": "The account Velanox signs in with through the tunnel. Stored encrypted, never shown again.",
  "devices.mikrotik.addUnit": "Add MikroTik",
  "devices.mikrotik.unitAdded": "MikroTik added",
  "devices.mikrotik.unitAddedText": "Its VPN certificate is issued: load its files on the unit from this page.",
  "devices.mikrotik.addFailed": "The MikroTik was not added",
  "devices.mikrotik.notDeployed.waiting": "Waiting for VPN",
  "devices.mikrotik.notDeployed.offline": "Offline · not deployed",
  "devices.mikrotik.waitingText": "The unit has not connected to the VPN yet; once it dials in, Velanox polls it through its tunnel.",
  "devices.mikrotik.vpn.connected": "Connected",
  "devices.mikrotik.vpn.waiting": "Waiting for the unit",
  "devices.mikrotik.vpn.noAccount": "This unit has no VPN certificate yet: add it again with the same serial number to issue one.",
  "devices.mikrotik.vpn.tunnelAddress": "Tunnel address",
  "devices.mikrotik.vpn.lastSeen": "Last connected",
  "devices.mikrotik.vpn.never": "Never",
  "devices.mikrotik.vpn.downloadOvpn": "Download .ovpn",
  "devices.mikrotik.vpn.downloadP12": "Download .p12",
  "devices.mikrotik.vpn.newCert": "New certificate",
  "devices.mikrotik.vpn.newCertConfirm": "Issue a new VPN certificate for {name}? The current one stops working at once; the unit stays off the VPN until it has the new files.",
  "devices.mikrotik.vpn.newCertDone": "New certificate issued",
  "devices.mikrotik.vpn.newCertDoneText": "Download the new files and load them on the unit.",
  "devices.mikrotik.vpn.newCertFailed": "No new certificate was issued",
  "devices.mikrotik.vpn.passphrase": "Passphrase of this .p12:",
  "devices.mikrotik.vpn.passphraseHint": "Shown once, for this download only; it is not stored. Each download gets a new one.",
  "devices.mikrotik.vpn.passphraseWord": "passphrase",
  "devices.mikrotik.vpn.commands": "Commands for RouterOS 7.17 or newer",
  "devices.mikrotik.vpn.commandsHint": "Upload both files to the unit (Files), then paste these in its terminal.",
  "devices.mikrotik.band.open": "Turn on or off, change the frequency",
  "devices.mikrotik.band.on": "Radio on",
  "devices.mikrotik.band.frequency": "Frequency",
  "devices.mikrotik.band.auto": "Automatic",
  "devices.mikrotik.band.channel": "{mhz} MHz · channel {n}",
  "devices.mikrotik.band.followsAp": "A station follows the frequency of its access point",
  "devices.mikrotik.band.offWarning": "{name} carries a radio link. Turning it off cuts that link: the unit at the other end can no longer be reached through it. If this unit is cut off too, it turns the radio back on by itself after 10 minutes. Turn {name} off?",
  "devices.mikrotik.band.applied": "Radio settings applied",
  "devices.mikrotik.band.applying": "Applying. If the change cuts the connection, this can take two minutes.",
  "devices.mikrotik.band.apply": "Apply",
  "devices.vpnPath": "Reached through its own VPN connection: after adding, load the site’s .ovpn on the router as an OpenVPN client. Nothing needs to be reachable now.",
  "devices.vpnAdded": "Site added",
  "devices.vpnAddedText": "Load its .ovpn on the router; the site comes online once it connects",
  "devices.teltonika.sim.title": "SIM card",
  "devices.teltonika.sim.slot": "SIM {slot}",
  "devices.teltonika.sim.active": "Active",
  "devices.teltonika.sim.locked": "Locked with PIN",
  "devices.teltonika.sim.unlocked": "Not locked",
  "devices.teltonika.sim.blocked": "Blocked: needs PUK",
  "devices.teltonika.sim.unknown": "Unknown",
  "devices.teltonika.sim.pinTries": "PIN tries left: {count}",
  "devices.teltonika.sim.pukTries": "PUK tries left: {count}",
  "devices.teltonika.sim.usesCompany": "Company PIN",
  "devices.teltonika.sim.usesOwn": "Own PIN",
  "devices.teltonika.sim.usesOwnNote": "Own PIN · {note}",
  "devices.teltonika.sim.usesNone": "No PIN known",
  "devices.teltonika.sim.storedMatches": "Router's stored PIN: matches",
  "devices.teltonika.sim.storedDiffers": "Router's stored PIN: doesn't match",
  "devices.teltonika.sim.storedUnknown": "Router's stored PIN: unknown",
  "devices.teltonika.sim.inactive": "Not the active SIM: its state is from when it was last active.",
  "devices.teltonika.sim.switchFirst": "Switch to this SIM first",
  "devices.teltonika.sim.lockCompany": "Lock with company PIN",
  "devices.teltonika.sim.useOwn": "Use own PIN",
  "devices.teltonika.sim.change": "Change PIN",
  "devices.teltonika.sim.unlock": "Unlock",
  "devices.teltonika.sim.unblockPuk": "Unblock with PUK",
  "devices.teltonika.sim.store": "Router's stored PIN",
  "devices.teltonika.sim.currentPin": "The SIM's current PIN",
  "devices.teltonika.sim.carrierHint": "a new SIM: its carrier's PIN",
  "devices.teltonika.sim.keptHint": "empty: the PIN Velanox keeps",
  "devices.teltonika.sim.newPin": "New PIN (4 to 8 digits)",
  "devices.teltonika.sim.simPin": "The SIM's PIN",
  "devices.teltonika.sim.puk": "PUK (8 digits)",
  "devices.teltonika.sim.note": "Note",
  "devices.teltonika.sim.noteHint": "e.g. loaner from …",
  "devices.teltonika.sim.toCompany": "Use the company PIN",
  "devices.teltonika.sim.lastTryConfirm": "One try left. A wrong PIN now blocks the SIM until its PUK is entered. Go on?",
  "devices.teltonika.sim.doneSteps": "Done: {steps}",
  "devices.teltonika.sim.failedStep": "Not done: {step}",
  "devices.teltonika.sim.step.change_pin": "PIN changed",
  "devices.teltonika.sim.step.check_on": "PIN check on",
  "devices.teltonika.sim.step.check_off": "PIN check off",
  "devices.teltonika.sim.step.unblock": "SIM unblocked",
  "devices.teltonika.sim.step.store": "router's stored PIN set",
  "devices.teltonika.sim.step.read": "state read",
  "devices.teltonika.sim.needsDirect": "Changing the SIM's PIN needs the router's direct or VPN connection.",
  "devices.teltonika.sim.notRead": "The SIM card is read with the next sync.",
  "devices.teltonika.sim.pinTriesUnknown": "PIN tries left: unknown",
  "devices.teltonika.sim.unknownTriesConfirm": "The tries left can't be read: this may be the last one, and a wrong PIN or PUK would block the SIM. Go on?",
  "devices.teltonika.sim.lastPukConfirm": "One PUK try left. A wrong PUK now makes the SIM unusable for good: only its carrier can replace it. Go on?",
  "devices.accessFix.teltonika": "Run this once on the router to let Velanox's VPN server {serverIp} in: in its WebUI under System → Maintenance → CLI, or over SSH from the router's own network.",
  "devices.accessFix.peplink": "Its API has no call for this: in the router's Web Admin, under System → Admin Security, allow HTTPS (port 443) and the source address {serverIp} (Velanox's VPN server) on the connection the VPN uses.",
  "devices.accessFix.copy": "Copy command",
}

export default devices
